__turbopack_context__.v({
  "className": "assistant_d21dd340-module__-voddG__className",
  "variable": "assistant_d21dd340-module__-voddG__variable",
});
